var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-718.000000, -359.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(718.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9986328,6.99589844 L13.9917969,6.99589844 C12.7982422,4.19453125 10.3632813,2.19296875 7.01640625,2.18203125 L7.00546875,2.18203125 C3.6421875,2.18203125 1.19492188,4.19179688 1.55431223e-15,7.00273438 C1.55431223e-15,7.00273438 1.55431223e-15,7.00410156 0.0013671875,7.00410156 L0.008203125,7.00410156 C1.20175781,9.80546875 3.63671875,11.8070313 6.98359375,11.8179688 L6.99453125,11.8179688 C10.3578125,11.8179688 12.8050781,9.80820313 14,6.99726563 L13.9986328,6.99589844 Z M7.00136719,10.2183594 C5.22265625,10.2183594 3.78300781,8.77734375 3.78300781,7 C3.78300781,5.22265625 5.22402344,3.78164063 7.00136719,3.78164063 C8.77871094,3.78164063 10.2197266,5.22265625 10.2197266,7 C10.2197266,8.77734375 8.77871094,10.2183594 7.00136719,10.2183594 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09414062,7 C5.09414062,8.05273438 5.94726562,8.90585938 7,8.90585938 C8.05273438,8.90585938 8.90585938,8.05273438 8.90585938,7 C8.90585938,5.94726562 8.05273438,5.09414062 7,5.09414062 C5.94863281,5.09414062 5.09414062,5.94726562 5.09414062,7 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.4c87e7aa734ea35175806f602031d07b.svg";
export { ForwardRef as ReactComponent };